import { Options } from '../options.interface';
import { CONTENT_API_CONFIG } from './content-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ArticleTypes } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

@Injectable()
export class ContentLegalWebservice {
  readonly #httpClient = inject(HttpClient);
  readonly #contentApiConfig = inject(CONTENT_API_CONFIG);

  readonly #baseUrl = this.#contentApiConfig.baseUrl;
  readonly #locale = this.#contentApiConfig.locale;

  getVersionsByServiceAndType(
    serviceId: string,
    type: ArticleTypes,
    options?: Options
  ): Observable<{ lastVersion: string }> {
    const service = type === ArticleTypes.CGU ? 'global' : serviceId;

    return this.#httpClient.get<{ lastVersion: string }>(
      `${this.#baseUrl}/v1/version/legal-galaxy/${type}/${service}/${this.#locale}`,
      options
    );
  }
}
